<template>
  <div v-if="!hideCopyRight" class="footer" :class="{ 'has-bar': hasBar }">
    腾宇一号提供技术支持
    <!-- 腾宇一号 • {{ copyright }} 提供技术支持 -->
  </div>
</template>
<script>
  export default {
    data() {
      return {
        copyright: '案例云',
        hasBar: false,
        hideCopyRight: false,
      }
    },
    watch: {
      $route: {
        handler(val) {
          if (val.meta) {
            this.hasBar = val.meta.hasBar
            this.copyright = val.meta.copyRight || '案例云'
            this.hideCopyRight = val.meta.hideCopyRight || false
          }
        },
        deep: true,
      },
    },
  }
</script>
